/**
 * One Heart — City of LimeZu (Phase 12 full rebuild).
 *
 * 320×200 tile world (10,240 × 6,400 px). 28 themed buildings + plaza,
 * connected by streets. Every paid LimeZu pack is referenced somewhere
 * in the city. See `TilemapRenderer.ts` for the building layout.
 */

export const TILE = 32;
export const COLS = 320;
export const ROWS = 200;
export const MAP_W_PX = COLS * TILE;   // 10240
export const MAP_H_PX = ROWS * TILE;   // 6400

// Plaza centre — players spawn here.
export const SPAWN = { x: 160 * TILE, y: 100 * TILE };

export type Tier = "VVIP" | "VIP" | "SENIOR";  // legacy compat — unused
export interface Room {
  id: string; name: string; tier: Tier; zhTier: string;
  x0: number; y0: number; x1: number; y1: number; doorCol: number;
}
export const ROOMS: Room[] = [];

export interface WallRect { x: number; y: number; w: number; h: number; }
export function buildWalls(): WallRect[] {
  const T = TILE;
  return [
    { x: 0, y: 0, w: COLS * T, h: T },
    { x: 0, y: (ROWS - 1) * T, w: COLS * T, h: T },
    { x: 0, y: 0, w: T, h: ROWS * T },
    { x: (COLS - 1) * T, y: 0, w: T, h: ROWS * T },
  ];
}

export const ZONES = {};
export function locateArea(_x: number, _y: number): string {
  return "city";
}
